import React, { FC, Fragment } from 'react';
import { Alert, IconButton, List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RemoveIcon from '@mui/icons-material/Remove';
import { User } from 'models/user';
import InfoText from '../info-text.component';

type ConnectedExternalUsersProps = {
    connectedExternalTechnicians: User[];
    onRemove: (technician: User) => void;
};
const ConnectedExternalUsers: FC<ConnectedExternalUsersProps> = ({
    connectedExternalTechnicians,
    onRemove,
}: ConnectedExternalUsersProps) => {
    const { t: translate } = useTranslation('workflow');

    const onRemoveClick = (technician: User) => {
        onRemove(technician);
    };

    return (
        <Fragment>
            {connectedExternalTechnicians.length > 0 ? (
                <Fragment>
                    <Typography variant="subtitle1">{translate('THIS_STEP_IS_SHARED_WITH')}:</Typography>
                    <Paper variant="outlined">
                        <List dense>
                            {connectedExternalTechnicians.map((technician) => (
                                <ListItem
                                    key={technician._id}
                                    secondaryAction={
                                        <IconButton
                                            edge="end"
                                            onClick={() => {
                                                onRemoveClick(technician);
                                            }}
                                        >
                                            <RemoveIcon />
                                        </IconButton>
                                    }
                                >
                                    <ListItemText primary={technician.fullName} />
                                </ListItem>
                            ))}
                        </List>
                    </Paper>
                </Fragment>
            ) : (
                <InfoText text={translate('THIS_STEP_IS_NOT_SHARED')} />
            )}
        </Fragment>
    );
};

export default ConnectedExternalUsers;
